import React from 'react';
import Box from '@mui/material/Box';

interface TabPanelProps {
  children: React.ReactNode;
  value: string | number;
  index: string | number;
  sx?: object;
}

const TabPanel: React.FC<TabPanelProps> = ({ children, value, index, sx }) => (
  <div role="tabpanel" hidden={value !== index}>
    {value === index && <Box sx={sx}>{children}</Box>}
  </div>
);

export default TabPanel;